import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PositioningUserGroupItemComponent } from './positioning-user-group-item.component';
import { FlexModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PositioningUserGroupItemComponent],
  exports: [PositioningUserGroupItemComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
})
export class PositioningUserGroupItemModule {}
